import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { COMPANY_INFO } from '../../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Services', path: '/services' },
    { name: 'Pricing Options', path: '/pricing' },
    { name: 'Book Collection', path: '/book/waste' },
    { name: 'Become a Subscriber', path: '/subscribe' },
  ];

  const supportLinks = [
    { name: 'Service Area', path: '/service-area' },
    { name: 'FAQs', path: '/faqs' },
    { name: 'About Us', path: '/about' },
    { name: 'Contact', path: '/contact' },
    { name: 'Client Portal', path: '/manage' },
  ];

  return (
    <footer className="footer-section">
      {/* Service Area Banner */}
      <div className="bg-[#0D9488] py-3">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-white text-sm font-medium flex items-center justify-center gap-2">
            <MapPin className="w-4 h-4" />
            Currently servicing Metro Melbourne LGAs only
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block">
              <img 
                src={COMPANY_INFO.logoUrl} 
                alt="Transa" 
                className="h-10 w-auto"
                style={{ filter: 'brightness(0) invert(1)' }}
              />
            </Link>
            <p className="mt-4 text-[#94A3B8] text-sm leading-relaxed">
              {COMPANY_INFO.tagline}. We collect bulky packaging from battery and electrical installs so you can keep working.
            </p>
            <div className="mt-6 space-y-3">
              <a 
                href={`tel:${COMPANY_INFO.phone}`}
                className="flex items-center gap-3 text-[#94A3B8] hover:text-[#0D9488] transition-colors text-sm"
              >
                <Phone className="w-4 h-4" />
                {COMPANY_INFO.phone}
              </a>
              <a 
                href={`mailto:${COMPANY_INFO.email}`}
                className="flex items-center gap-3 text-[#94A3B8] hover:text-[#0D9488] transition-colors text-sm"
              >
                <Mail className="w-4 h-4" />
                {COMPANY_INFO.email}
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path}
                    className="footer-link text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Support</h4>
            <ul className="space-y-3">
              {supportLinks.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path}
                    className="footer-link text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Service Area Info */}
          <div>
            <h4 className="text-white font-semibold mb-4">Service Area</h4>
            <p className="text-[#94A3B8] text-sm leading-relaxed mb-4">
              Phase 1: Metro Melbourne Local Government Areas only.
            </p>
            <Link 
              to="/service-area"
              className="inline-flex items-center gap-2 text-[#0D9488] hover:text-[#14B8A6] transition-colors text-sm font-medium"
            >
              Check your postcode
              <span aria-hidden="true">→</span>
            </Link>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-[#1F2937]">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-[#64748B] text-sm">
              © {currentYear} {COMPANY_INFO.name}. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <Link to="/terms" className="text-[#64748B] hover:text-[#0D9488] text-sm transition-colors">
                Terms & Conditions
              </Link>
              <span className="text-[#374151]">|</span>
              <Link to="/privacy" className="text-[#64748B] hover:text-[#0D9488] text-sm transition-colors">
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
